// extracted by mini-css-extract-plugin
export default {"gallery":"c-o_fH","gallery__header":"c-o_fJ","gallery__thumbs":"c-o_fK"};